import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button } from '@els/els-react--button';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ViewFullPatentFamily from '@Containers/PatentFamilyClustering/Components/ViewFullPatentFamily';
import useExpandPatentFamilyGroupFromBreadcrumb from '@Containers/PatentFamilyClustering/hooks/useExpandPatentFamilyGroupFromBreadcrumb';

function PatentFamilyHeading({
  metadata,
  document,
  title,
  offices,
  viewFullPatentFamily,
  mainDocumentFirstSectionExpanded,
  onFamilyGroupTitleClick,
  getTrackingAttrs,
}) {
  const displayViewFullPatentFamilyLink = !useExpandPatentFamilyGroupFromBreadcrumb({ document, metadata });

  return (
    <div className="patent-family-heading">
      <Button
        data-e2e="patent-family-title"
        type="link"
        onClick={onFamilyGroupTitleClick}
        linkOptions={['navigation']}
        className={cn('patent-family-heading__title-button', {
          'patent-family-heading__title-button--first-section-expanded': mainDocumentFirstSectionExpanded,
        })}
        {...getTrackingAttrs({
          'data-tracking': !mainDocumentFirstSectionExpanded,
          'data-tracking-type': 'contentlinkclick',
          'data-tracking-action': 'title',
        })}>
        {title ? (
          <InnerHTML tag="h2" className="patent-family-heading__title u-els-font-family-serif" html={title} />
        ) : (
          <span className="patent-family-heading__title u-els-font-family-serif">No title</span>
        )}
      </Button>
      <div className="patent-family-heading__offices-row">
        {offices ? (
          <div className="patent-family-heading__offices">
            <span>{`Office${offices.length > 1 ? 's' : ''}:`}&nbsp;</span>
            <ul className="patent-family-heading__offices-list" role="tablist" aria-label="Patent Offices">
              {offices.map((office, index) => (
                <li key={office}>
                  {office}
                  {index < offices.length - 1 && <>,&nbsp;</>}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        {displayViewFullPatentFamilyLink && (
          <ViewFullPatentFamily metadata={metadata} document={document} viewFullPatentFamily={viewFullPatentFamily} />
        )}
      </div>
    </div>
  );
}

PatentFamilyHeading.propTypes = {
  metadata: MetadataPropTypesShape,
  document: PropTypes.object.isRequired,
  title: PropTypes.string,
  offices: PropTypes.array,
  viewFullPatentFamily: PropTypes.func.isRequired,
  mainDocumentFirstSectionExpanded: PropTypes.bool,
  onFamilyGroupTitleClick: PropTypes.func.isRequired,
  getTrackingAttrs: PropTypes.func.isRequired,
};

export default PatentFamilyHeading;
